export const getYoutubeIframeTag = (embedURL: string) =>
    `<iframe src="${embedURL}&autoplay=1" allowfullscreen allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"/>`;
